module.exports = __webpack_public_path__ + "static/img/35.431a74da.jpeg";